<div class="confirm-modal">

    <button class="confirm-modal-close" (click)="onConfirm(false)" aria-label="Close">
        <span class="mdi mdi-close"></span>
    </button>

    <div class="confirm-modal-icon confirm-modal-icon--{{ options.type }}">
        <span class="mdi {{ iconClass }}"></span>
    </div>

    <h5 class="confirm-modal-title">{{ options.title }}</h5>

    @if (options.description) {
        <p class="confirm-modal-description">{{ options.description }}</p>
    }

    <div class="confirm-modal-actions">
        @if (options.showCloseButton) {
            <button
                class="confirm-modal-btn confirm-modal-btn--cancel"
                (click)="onConfirm(false)"
            >
                {{ options.closeButtonText }}
            </button>
        }
        @if (options.showConfirmButton) {
            <button
                class="confirm-modal-btn confirm-modal-btn--{{ options.type }}"
                (click)="onConfirm(true)"
            >
                {{ options.confirmButtonText }}
            </button>
        }
    </div>

</div>
